import moment from 'moment';
import { CalendarTiers } from '../../sdk/plans';

export const getSelectedTier = (tiers?: CalendarTiers['priceTiers'], current?: string) => {
  if (current) {
    const tier = tiers?.find((t) => moment(current).isBefore(t.upto))
    return tier?.name;
  }
}